import { createActionType, createApiActionType } from 'app/store/utils';

const apiType = createApiActionType('qualityChecks');
const type = createActionType('qualityChecks');

export const LIST_MODEL_CHECKS_ACTION = apiType('ListModelChecks');
export const SET_MODEL_CHECKS_ACTION = apiType('SetModelChecks');

export const ADD_CHECK = type('AddCheck');
export const EDIT_CHECK = type('EditCheck');
export const TOGGLE_CHECK = type('ToggleCheck');
